import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { GridRow } from 'dibs-elements/exports/Grid';
import HpRespPromoModulePromoItem from './HpRespPromoModulePromoItem';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

import { HpRespPromoModuleSecondary_componentModule } from './__generated__/HpRespPromoModuleSecondary_componentModule.graphql';

type Props = {
    componentModule: HpRespPromoModuleSecondary_componentModule;
    promoPrimaryItemsCount: number;
    useLazyLoadImages: boolean;
    isMobile: boolean;
};

const HpRespPromoModuleSecondary: FC<Props> = ({
    componentModule,
    promoPrimaryItemsCount,
    useLazyLoadImages,
    isMobile,
}) => {
    if (!componentModule) {
        return null;
    }

    const items = (componentModule.items || []).filter(filterNulls);
    const isSinglePromo = items.length === 1;

    const handleInitialDisplay = ({ inViewport }: { inViewport: boolean }): void => {
        if (componentModule && inViewport) {
            trackPromoImpressions({
                items,
                startingIndex: promoPrimaryItemsCount,
            });
        }
    };

    return (
        <HpRespModuleContainerOld addTopGap>
            <SharedInViewport stopWhenInViewport onInViewportChange={handleInitialDisplay}>
                <GridRow>
                    {items.map((promotion, index) => (
                        <HpRespPromoModulePromoItem
                            key={promotion?.cmsId || index}
                            promotion={promotion}
                            useLazyLoadImages={useLazyLoadImages}
                            onClick={() =>
                                trackPromoClick({
                                    item: promotion,
                                    index: index + promoPrimaryItemsCount,
                                })
                            }
                            isSinglePromo={isSinglePromo}
                            isMobile={isMobile}
                        />
                    ))}
                </GridRow>
            </SharedInViewport>
        </HpRespModuleContainerOld>
    );
};

export default createFragmentContainer(HpRespPromoModuleSecondary, {
    componentModule: graphql`
        fragment HpRespPromoModuleSecondary_componentModule on PromoModule {
            title
            items {
                cmsId
                linkData {
                    # path is used in PromoTrackingOld.js
                    path
                }
                ...HpRespPromoModulePromoItem_promotion
            }
        }
    `,
});
